import { forwardRef, type InputHTMLAttributes } from "react";
import { cx } from "./cx";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Render with the mono/tabular face (matricule, codes, montants, unités). */
  mono?: boolean;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { mono, invalid, className, "aria-invalid": ariaInvalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cx("nv-field", mono && "nv-field--mono", invalid && "nv-field--invalid", className)}
      aria-invalid={ariaInvalid ?? invalid ?? undefined}
      {...rest}
    />
  );
});
